import React, { useCallback, useState } from "react";
import { TableHeaderColumn } from "react-bootstrap-table";
import Report from "../Report";
import { TextField } from "@material-ui/core";
import {
  dateReportFormatter,
  durationReportFormatter,
} from "../../fomatters/DateFormatter";
import InputSelect from "../InputSelect";
import { useDataFormatterHook } from "../../../hooks/useDataFormatterHook";

/**
 * TABLE FREEPLAYOFFICEOPTIONS
 */
function MailingList() {
  const [player, setPlayer] = useState("");
  const onPlayerChanged = useCallback(
    (event) => setPlayer(event.target.value),
    []
  );

  const [agent, setAgent] = useState("");
  const onAgentChanged = useCallback(
    (event) => setAgent(event.target.value),
    []
  );

  const [book, setBook] = useState("");
  const onBookChanged = useCallback((b) => setBook(b), []);
  const { values: books } = useDataFormatterHook({
    addEmpty: true,
    value: "description",
    text: "description",
    path: `/Player/GetBooks`,
  });

  const [group, setGroup] = useState("");
  const onGroupChanged = useCallback((g) => setGroup(g), []);
  const { values: groups } = useDataFormatterHook({
    addEmpty: true,
    value: "groupName",
    text: "groupName",
    path: `/Player/Grouping_GetList`,
  });

  const [lineType, setLineType] = useState("");
  const onLineTypeChanged = useCallback((l) => setLineType(l), []);
  const { values: lineTypes } = useDataFormatterHook({
    addEmpty: true,
    value: "description",
    text: "description",
    path: `/LineType/GetLineTypes`,
  });

  return (
    <div className="flex flex-col gap-4 p-4 h-max">
      <div className="grid grid-cols-2 gap-4">
        <InputSelect
          variant="outlined"
          size="small"
          label="Book"
          name="name"
          data={books}
          placeholder="DataFormatter"
          setSelectValue={onBookChanged}
          startValue={""}
        />
        <TextField
          required
          variant="outlined"
          label="Player"
          type="text"
          value={player}
          size="small"
          onChange={onPlayerChanged}
          InputLabelProps={{ shrink: true }}
        />
        <InputSelect
          variant="outlined"
          size="small"
          label="Group"
          name="name"
          data={groups}
          placeholder="DataFormatter"
          setSelectValue={onGroupChanged}
          startValue={""}
        />
        <TextField
          required
          variant="outlined"
          label="Agent"
          type="text"
          value={agent}
          size="small"
          onChange={onAgentChanged}
          InputLabelProps={{ shrink: true }}
        />
        <InputSelect
          variant="outlined"
          size="small"
          label="Line Type"
          name="name"
          data={lineTypes}
          placeholder="DataFormatter"
          setSelectValue={onLineTypeChanged}
          startValue={""}
        />
      </div>
      <Report
        title="Mailing List Report"
        getUrl={() => "/Reports/Report_Mailing_List_2"}
        getParams={({ userId }) => ({
          IdUser: Number(userId),
          Book: book,
          Player: player,
          Group: group,
          Agent: agent,
          LineType: lineType,
        })}
        getTotals={(data) => ({
          player: "",
          phoneLine: "Calls",
          loginname: data.length,
          startTime: "",
          endTime: "Totals",
          duration: data.reduce((acc, item) => acc + item.duration, 0),
          betstaked: data.reduce((acc, item) => acc + item.betstaked, 0),
        })}
      >
        <TableHeaderColumn dataSort dataField="Id" isKey hidden>
          Id
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="player">
          Player
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="address1">
          Address 1
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="address2">
          Address 2
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="city">
          City
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="state">
          State
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="country">
          Country
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="zip">
          Zip
        </TableHeaderColumn>
      </Report>
    </div>
  );
}

export default MailingList;
